<template>
  <router-view />
  <!-- <router-view :key='key'/> -->
</template>

<script>
export default {
  computed: {
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route + new Date();
    }
  },
  created() {
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("state")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("state"))
        )
      );
    }
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("state", JSON.stringify(this.$store.state));
      // console.log("我是保存store数据的 ----ok");
    });
    // console.log(
    //   "////////////////////////////////////////////////////////////////////\n//                          _ooOoo_                               //\n//                         o8888888o                              //\n//                         88' . '88                              //\n//                         (| ^_^ |)                              //\n//                         O  =  /O                              //\n//                      ____/`---'____                           //\n//                    .'  \\|     |//  `.                         //\n//                   /  \\|||  :  |||//                          //\n//                  /  _||||| -:- |||||-                         //\n//                  |   | \\  -  /// |   |                       //\n//                  | _|  ''---/''  |   |                       //\n//                    .-__  `-`  ___/-. /                       //\n//                ___`. .'  /--.--  `. . ___                     //\n//              .'' '<  `.____<|>_/___.'  >'''.                  //\n//            | | :  `- `.;` _ /`;.`/ - ` : | |                 //\n//               `-.   _ __ /__ _/   .-` /  /                 //\n//      ========`-.____`-.________/___.-`____.-'========         //\n//                           `=---='                              //\n//      ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^        //\n//            佛祖保佑       永不宕机     永无BUG                    //\n////////////////////////////////////////////////////////////////////"
    // );
  }
};
</script>

<style lang="scss">
</style>
